
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Profile } from "@/hooks/profile/types";

interface DeleteUserDialogProps {
  user: Profile | null;
  onClose: () => void;
  onConfirm: (userId: string) => void;
  isRemoveFromGym?: boolean;
}

export const DeleteUserDialog = ({ 
  user, 
  onClose, 
  onConfirm, 
  isRemoveFromGym = false 
}: DeleteUserDialogProps) => {
  if (!user) return null;

  const handleConfirm = () => {
    onConfirm(user.id);
  };

  return (
    <AlertDialog open={!!user} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isRemoveFromGym ? "¿Remover usuario del gimnasio?" : "¿Eliminar usuario?"}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {isRemoveFromGym ? (
              <>
                Esta acción removerá a <strong>{user.first_name} {user.last_name}</strong> del gimnasio.
                El usuario seguirá existiendo en el sistema pero perderá acceso a este gimnasio específico.
              </>
            ) : (
              <>
                Esta acción eliminará permanentemente a <strong>{user.first_name} {user.last_name}</strong> del sistema.
                Esta acción no se puede deshacer.
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Cancelar</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isRemoveFromGym ? "Remover del gimnasio" : "Eliminar usuario"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
